/**
 * Filtered templates slice (RTK). Same state shape as reducer-FilteredTemplates.
 */
import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_SEARCH_RESULT_COUNT,
  DEFAULT_SELECTED_PAGE_INDEX,
} from "../../constants/metaData";

const extractValue = (payload) =>
  payload !== null && payload !== ""
    ? payload.value !== null
      ? payload.value
      : []
    : [];

const initialState = {
  "@odata.context": null,
  value: [],
  SearchTemplateResultCount: DEFAULT_SEARCH_RESULT_COUNT,
  selectedPageIndex: DEFAULT_SELECTED_PAGE_INDEX,
  enableSpinner: false,
  spinnerText: "",
  versionData: {},
  envData: "",
  error: {},
  downloadData: "",
};

const filteredTemplatesSlice = createSlice({
  name: "filteredTemplates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_TEMPLATE_SEARCH_FILTERED", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("SET_INITIAL_VALUE", (state) => {
        state.value = [];
        state.SearchTemplateResultCount = -1;
      })
      .addCase("GET_RECENT_DOCUMENT_BY_USER", (state, action) => {
        state.value = action.payload.value;
      })
      .addCase("ON_PAGE_CHANGE", (state, action) => {
        state.value = action.payload;
      })
      .addCase("ON_SET_DOCUMENT_INITIAL_STATE", (state, action) => {
        state.value = action.payload;
        state.SearchTemplateResultCount = 0;
        state.selectedPageIndex = 0;
      })
      .addCase("ON_DOWNLOAD_CLICK", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.error = p.error;
      })
      .addCase("ON_SET_VERSION_DETAILS", (state, action) => {
        state.versionData = action.payload;
      })
      .addCase("ON_SET_IFS_ENV_DETAILS", (state, action) => {
        state.envData = action.payload;
        state.error = action.payload.error;
      });
  },
});

export default filteredTemplatesSlice;
